import {
  API_FUND,
  API_FUND_ACTIVITY,
  API_FUND_ALLOCATION_BY_ID,
  API_FUND_ALLOCATION_REPRINT,
  API_FUND_ASSET_BY_ID,
  API_FUND_ASSETS,
  API_FUND_AUDIT_PACK,
  API_FUND_AUDIT_PACK_CSV,
  API_FUND_AVAILABLE_INVESTORS,
  API_FUND_BY_ID,
  API_FUND_CAPITAL_YEAR,
  API_FUND_CAPITAL_YEARS,
  API_FUND_CERTIFICATE,
  API_FUND_CERTIFICATE_SURRENDER,
  API_FUND_CERTIFICATES,
  API_FUND_CERTIFICATES_BY_POSITION,
  API_FUND_COMBINED_PAYOUT,
  API_FUND_COMBINED_QUEUE,
  API_FUND_COMPLIANCE,
  API_FUND_CONTRIBUTION,
  API_FUND_DIRECTORY,
  API_FUND_DIRECTORY_ACTIVITY,
  API_FUND_DIRECTORY_BY_ID,
  API_FUND_DIRECTORY_STATEMENT,
  API_FUND_DIRECTORY_STATEMENT_EMAIL,
  API_FUND_DISTRIBUTION_APPROVE,
  API_FUND_DISTRIBUTION_BY_ID,
  API_FUND_DISTRIBUTION_PREVIEW,
  API_FUND_DISTRIBUTION_RECALCULATE,
  API_FUND_DISTRIBUTION_REVERSE,
  API_FUND_DISTRIBUTIONS,
  API_FUND_EXCHANGE,
  API_FUND_EXCHANGES,
  API_FUND_HOLDINGS,
  API_FUND_INVESTOR_BY_ID,
  API_FUND_INVESTOR_DETAIL,
  API_FUND_INVESTORS,
  API_FUND_LEDGER,
  API_FUND_LIABILITIES,
  API_FUND_LIABILITY_BY_ID,
  API_FUND_NAV,
  API_FUND_NAV_BY_ID,
  API_FUND_NAV_CALCULATE,
  API_FUND_NAV_FINALIZE,
  API_FUND_PAYOUT_BY_ID,
  API_FUND_PAYOUT_DEPOSIT_NOTICES,
  API_FUND_PAYOUT_DEPOSIT_NOTICES_SEND,
  API_FUND_PAYOUT_NACHA,
  API_FUND_PAYOUT_PROVIDER,
  API_FUND_PAYOUT_QUEUE,
  API_FUND_PAYOUT_REVERSE,
  API_FUND_PAYOUT_SUBMIT_PROVIDER,
  API_FUND_PAYOUTS,
  API_FUND_RECONCILIATION,
  API_FUND_REDEMPTION,
  API_FUND_REPORT,
  API_FUND_REPORT_CATALOG,
  API_FUND_REPORT_CSV,
  API_FUND_RETURNS,
  API_FUND_STATEMENT,
  API_FUND_STATEMENT_EMAIL,
  API_FUND_SYNC,
  API_FUND_TAX_CLOSE,
  API_FUND_TAX_STATEMENTS,
  API_FUND_TAX_YEAR,
  API_FUND_TRANSACTION,
  API_FUND_TRANSACTION_BY_ID,
  API_FUND_TRANSFER,
  API_FUND_TRANSFERS,
  API_FUND_TRUSTEE_BY_ID,
  API_FUND_TRUSTEES,
} from 'config'
import Api from 'services/api'

import { downloadFile } from './documents'

// ── funds
export const getFunds = (query: Record<string, any>) => Api.get(API_FUND, query)
export const getFund = (id: number) => Api.get(API_FUND_BY_ID, {}, { id })
export const createFund = (data: Record<string, any>) => Api.post(API_FUND, data)
export const updateFund = (id: number, data: Record<string, any>) => Api.put(API_FUND_BY_ID, data, { id })
export const deleteFund = (id: number) => Api.delete(API_FUND_BY_ID, {}, { id })
export const syncFund = (id: number) => Api.post(API_FUND_SYNC, {}, { id })

// ── position
export const getFundHoldings = (id: number) => Api.get(API_FUND_HOLDINGS, {}, { id })
export const getFundInvestorDetail = (id: number, positionId: number) =>
  Api.get(API_FUND_INVESTOR_DETAIL, {}, { id, positionId })
export const getFundLedger = (id: number, query: Record<string, any> = {}) => Api.get(API_FUND_LEDGER, query, { id })
export const createFundTransaction = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_TRANSACTION, data, { id })
export const deleteFundTransaction = (transactionId: number) =>
  Api.delete(API_FUND_TRANSACTION_BY_ID, {}, { transactionId })

// ── the asset register: what the fund owns beyond its loans and its cash
export const getFundAssets = (id: number) => Api.get(API_FUND_ASSETS, {}, { id })
export const addFundAsset = (id: number, data: Record<string, any>) => Api.post(API_FUND_ASSETS, data, { id })
export const updateFundAsset = (assetId: number, data: Record<string, any>) =>
  Api.put(API_FUND_ASSET_BY_ID, data, { assetId })
export const deleteFundAsset = (assetId: number) => Api.delete(API_FUND_ASSET_BY_ID, {}, { assetId })

// ── the liability register: what the fund owes, whether or not it strikes a NAV
export const getFundLiabilities = (id: number) => Api.get(API_FUND_LIABILITIES, {}, { id })
export const addFundLiability = (id: number, data: Record<string, any>) => Api.post(API_FUND_LIABILITIES, data, { id })
export const updateFundLiability = (liabilityId: number, data: Record<string, any>) =>
  Api.put(API_FUND_LIABILITY_BY_ID, data, { liabilityId })
export const deleteFundLiability = (liabilityId: number) => Api.delete(API_FUND_LIABILITY_BY_ID, {}, { liabilityId })

// ── the investor directory
export const getFundDirectory = (query: Record<string, any>) => Api.get(API_FUND_DIRECTORY, query)
export const getDirectoryInvestor = (investorId: number) => Api.get(API_FUND_DIRECTORY_BY_ID, {}, { investorId })
export const createDirectoryInvestor = (data: Record<string, any>) => Api.post(API_FUND_DIRECTORY, data)
export const updateDirectoryInvestor = (investorId: number, data: Record<string, any>) =>
  Api.put(API_FUND_DIRECTORY_BY_ID, data, { investorId })
export const deleteDirectoryInvestor = (investorId: number) => Api.delete(API_FUND_DIRECTORY_BY_ID, {}, { investorId })
export const getDirectoryInvestorActivity = (investorId: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_DIRECTORY_ACTIVITY, query, { investorId })
export const getAvailableInvestors = (id: number) => Api.get(API_FUND_AVAILABLE_INVESTORS, {}, { id })
export const getFundStatementPdf = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_STATEMENT, query, { id })
export const emailFundStatement = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_STATEMENT_EMAIL, data, { id })
export const getInvestorStatementPdf = (investorId: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_DIRECTORY_STATEMENT, query, { investorId })
export const emailInvestorStatement = (investorId: number, data: Record<string, any>) =>
  Api.post(API_FUND_DIRECTORY_STATEMENT_EMAIL, data, { investorId })

// ── payouts across every pool
export const getCombinedPayoutQueue = () => Api.get(API_FUND_COMBINED_QUEUE, {})
export const payCombinedDistributions = (data: Record<string, any>) => Api.post(API_FUND_COMBINED_PAYOUT, data)

// ── positions in a pool
export const getFundInvestors = (id: number) => Api.get(API_FUND_INVESTORS, {}, { id })
export const addFundInvestor = (id: number, data: Record<string, any>) => Api.post(API_FUND_INVESTORS, data, { id })
export const updateFundInvestor = (investorId: number, data: Record<string, any>) =>
  Api.put(API_FUND_INVESTOR_BY_ID, data, { investorId })
export const deleteFundInvestor = (investorId: number) => Api.delete(API_FUND_INVESTOR_BY_ID, {}, { investorId })
export const recordFundContribution = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_CONTRIBUTION, data, { id })
export const recordFundRedemption = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_REDEMPTION, data, { id })

// ── valuations
export const getFundNavSnapshots = (id: number) => Api.get(API_FUND_NAV, {}, { id })
export const calculateFundNav = (id: number, asOfDate?: string) =>
  Api.get(API_FUND_NAV_CALCULATE, asOfDate ? { asOfDate } : {}, { id })
export const createFundNavSnapshot = (id: number, data: Record<string, any>) => Api.post(API_FUND_NAV, data, { id })
export const updateFundNavSnapshot = (snapshotId: number, data: Record<string, any>) =>
  Api.put(API_FUND_NAV_BY_ID, data, { snapshotId })
export const finalizeFundNavSnapshot = (snapshotId: number) => Api.post(API_FUND_NAV_FINALIZE, {}, { snapshotId })
export const deleteFundNavSnapshot = (snapshotId: number) => Api.delete(API_FUND_NAV_BY_ID, {}, { snapshotId })

// ── distributions
export const getFundDistributions = (id: number) => Api.get(API_FUND_DISTRIBUTIONS, {}, { id })
export const previewFundDistribution = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_DISTRIBUTION_PREVIEW, data, { id })
export const createFundDistribution = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_DISTRIBUTIONS, data, { id })
export const getFundDistribution = (runId: number) => Api.get(API_FUND_DISTRIBUTION_BY_ID, {}, { runId })
export const updateFundDistribution = (runId: number, data: Record<string, any>) =>
  Api.put(API_FUND_DISTRIBUTION_BY_ID, data, { runId })
export const recalculateFundDistribution = (runId: number) => Api.post(API_FUND_DISTRIBUTION_RECALCULATE, {}, { runId })
export const approveFundDistribution = (runId: number) => Api.post(API_FUND_DISTRIBUTION_APPROVE, {}, { runId })
export const reverseFundDistribution = (runId: number) => Api.post(API_FUND_DISTRIBUTION_REVERSE, {}, { runId })
export const deleteFundDistribution = (runId: number) => Api.delete(API_FUND_DISTRIBUTION_BY_ID, {}, { runId })
export const updateFundAllocation = (allocationId: number, data: Record<string, any>) =>
  Api.put(API_FUND_ALLOCATION_BY_ID, data, { allocationId })

// ── payouts
export const getFundPayoutQueue = (id: number) => Api.get(API_FUND_PAYOUT_QUEUE, {}, { id })
export const getFundPayoutRuns = (id: number) => Api.get(API_FUND_PAYOUTS, {}, { id })
export const payFundDistributions = (id: number, data: Record<string, any>) => Api.post(API_FUND_PAYOUTS, data, { id })
export const getFundPayoutRun = (payoutRunId: number) => Api.get(API_FUND_PAYOUT_BY_ID, {}, { payoutRunId })
export const getFundPayoutNacha = (payoutRunId: number) => Api.get(API_FUND_PAYOUT_NACHA, {}, { payoutRunId })
export const reverseFundPayoutRun = (payoutRunId: number) => Api.post(API_FUND_PAYOUT_REVERSE, {}, { payoutRunId })
/** Whether ACH runs can be sent to USIO, and USIO's disbursement balance. */
export const getFundPayoutProvider = () => Api.get(API_FUND_PAYOUT_PROVIDER)
/** Send an ACH payout run's credits to USIO instead of taking the NACHA file to the bank. */
export const submitFundPayoutToProvider = (payoutRunId: number) =>
  Api.post(API_FUND_PAYOUT_SUBMIT_PROVIDER, {}, { payoutRunId })

/** Which investors an ACH payout run would email a Notice of Deposit, and whether each can be reached. */
export const getFundDepositNotices = (payoutRunId: number) =>
  Api.get(API_FUND_PAYOUT_DEPOSIT_NOTICES, {}, { payoutRunId })

/** Email a Notice of Deposit to each investor in the run — optionally limited to specific references. */
export const sendFundDepositNotices = (payoutRunId: number, references?: string[]) =>
  Api.post(API_FUND_PAYOUT_DEPOSIT_NOTICES_SEND, references?.length ? { references } : {}, { payoutRunId })
export const reprintFundAllocation = (allocationId: number) =>
  Api.post(API_FUND_ALLOCATION_REPRINT, {}, { allocationId })

// ── reporting
/** The report catalog, so the picker and its parameter form are built from the server's own list. */
export const getFundReportCatalog = () => Api.get(API_FUND_REPORT_CATALOG)

export const getFundReport = (id: number, reportId: string, query: Record<string, any> = {}) =>
  Api.get(API_FUND_REPORT, query, { id, reportId })

/** The same report as a CSV. Named from the fund and the as-of date, which a report without is unusable. */
export const downloadFundReportCsv = async (
  id: number,
  reportId: string,
  query: Record<string, any> = {},
  fileName = `${reportId}.csv`,
) => {
  const res: Blob = await Api.get(API_FUND_REPORT_CSV, query, { id, reportId }, { responseType: 'blob' })
  downloadFile(fileName, res)
}

export const getFundReconciliation = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_RECONCILIATION, query, { id })

// ── outside audit
/** Whether the fund was run the way its own documents say it is run. */
export const getFundCompliance = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_COMPLIANCE, query, { id })

/** Who did what to the fund over a period, read out of the fund's own records. */
export const getFundActivity = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_ACTIVITY, query, { id })

/** Everything an outside accountant asks for about one fund and one period. */
export const getFundAuditPack = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_AUDIT_PACK, query, { id })

/**
 * The pack as one CSV, which is the form an auditor asks for it in.
 *
 * The period is in the file name because a pack without one cannot be filed: an auditor holding
 * two of these months apart has no other way to tell them apart.
 */
export const downloadFundAuditPackCsv = async (
  id: number,
  query: Record<string, any> = {},
  fileName = 'audit-pack.csv',
) => {
  const res: Blob = await Api.get(API_FUND_AUDIT_PACK_CSV, query, { id }, { responseType: 'blob' })
  downloadFile(fileName, res)
}

// ── custodians (company-wide, not per fund)
/**
 * Custodians. Only active ones unless `includeInactive` is set, which an admin list and a picker
 * holding an already-chosen custodian both need: a deactivated one still has to show where it is
 * the holder of record on something already issued.
 */
export const getFundTrustees = (query: Record<string, any> = {}) => Api.get(API_FUND_TRUSTEES, query)
export const createFundTrustee = (data: Record<string, any>) => Api.post(API_FUND_TRUSTEES, data)
export const updateFundTrustee = (trusteeId: number, data: Record<string, any>) =>
  Api.put(API_FUND_TRUSTEE_BY_ID, data, { trusteeId })
/** Deactivated rather than deleted when any investor still names it. */
export const deleteFundTrustee = (trusteeId: number) => Api.delete(API_FUND_TRUSTEE_BY_ID, {}, { trusteeId })

// ── certificates
/** Live certificates for the fund. Issuing again for a position surrenders the one it replaces. */
export const getFundCertificates = (id: number) => Api.get(API_FUND_CERTIFICATES, {}, { id })
export const issueFundCertificate = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_CERTIFICATE, data, { id })
export const getPositionCertificates = (positionId: number) =>
  Api.get(API_FUND_CERTIFICATES_BY_POSITION, {}, { positionId })
export const surrenderFundCertificate = (certificateId: number, data: Record<string, any> = {}) =>
  Api.put(API_FUND_CERTIFICATE_SURRENDER, data, { certificateId })

// ── transfers
export const getFundTransfers = (id: number) => Api.get(API_FUND_TRANSFERS, {}, { id })
/** Moves units or capital only. No cash moves and lifetime contributions are untouched. */
export const recordFundTransfer = (id: number, data: Record<string, any>) => Api.post(API_FUND_TRANSFER, data, { id })

// ── moves between two funds
export const getFundExchanges = (id: number) => Api.get(API_FUND_EXCHANGES, {}, { id })
/**
 * Moves an investor's money from this fund into another one, as a single linked event.
 *
 * `treatment` decides how it is booked and has no default, because the two cases are different
 * events that look identical on a bank statement: 'exchange' posts a redemption and a contribution
 * (a voluntary switch, which is a disposal), 'transfer' posts transferOut/transferIn (a custodian
 * or trustee change, where neither fund's capital raised moves).
 */
export const recordFundExchange = (id: number, data: Record<string, any>) => Api.post(API_FUND_EXCHANGE, data, { id })

// ── tax
export const getFundTaxYear = (id: number, taxYear: number) => Api.get(API_FUND_TAX_YEAR, {}, { id, taxYear })
export const getFundTaxStatements = (id: number, taxYear: number) =>
  Api.get(API_FUND_TAX_STATEMENTS, {}, { id, taxYear })
export const closeFundTaxYear = (id: number, taxYear: number) => Api.post(API_FUND_TAX_CLOSE, {}, { id, taxYear })
export const getFundCapitalYears = (id: number, query: Record<string, any> = {}) =>
  Api.get(API_FUND_CAPITAL_YEARS, query, { id })
/** An opening balance by hand, for a fund whose history pre-dates us. */
export const setFundCapitalYear = (id: number, data: Record<string, any>) =>
  Api.post(API_FUND_CAPITAL_YEAR, data, { id })

/** Money-weighted return per investor. A position with no measurable return reports null, not zero. */
export const getFundReturns = (id: number, query: Record<string, any> = {}) => Api.get(API_FUND_RETURNS, query, { id })
